import { isObject } from 'util';
import { DtoInclude, DtoIncludeJson, DtoIncludeNumber, DtoRef } from '../../../core/store/dto/dto';
import { RestrictedAccountObjectDto } from '../restricted-account-object/restricted-account-object.dto';
import { ControlConfig } from './control-config.model';

export class ControlDto extends RestrictedAccountObjectDto {
    @DtoInclude
    name: string;
    @DtoInclude
    title: string;
    @DtoIncludeNumber
    sequence: number;
    @DtoInclude
    description: string;
    @DtoInclude
    descriptionImage: string;
    @DtoInclude
    defaultValue: string;
    @DtoIncludeJson
    config: ControlConfig;
    @DtoRef
    controlType: string;
    @DtoRef
    group: string;
    @DtoInclude
    validators: Array<string>;
    @DtoInclude
    linkable: boolean;

    getRequestBody(): any {
        const body = super.getRequestBody();

        if (isObject(this.defaultValue)) {
            body.defaultValue = JSON.stringify(this.defaultValue);
        }

        return body;
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control.dto.ts